import { SelectBox } from '@etg/wings';
import { optionListStyles } from './styles';
import OptionLabel from './OptionLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionsList = ({
  formattedOptions,
  onOptionClick
}) => {
  return /*#__PURE__*/_jsx("ul", {
    className: optionListStyles,
    "data-testid": "options-list",
    role: "list",
    children: formattedOptions.map(option => /*#__PURE__*/_jsx(SelectBox.Option, {
      isMultiple: true,
      label: /*#__PURE__*/_jsx(OptionLabel, {
        label: option.label,
        price: option.price
      }),
      onClick: event => onOptionClick(event, option),
      value: option
    }, option.value))
  });
};
export default OptionsList;
//# sourceMappingURL=OptionsList.js.map